import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { ASSET_METADATA, ASSET_TYPE, Asset, AssetsUser, FIREARM_TYPE, Firearm, RefCode, setDefaultLocationFromUser } from 'assets-model';
import { AssetService, FirearmService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class FirearmItemComponentBase extends CrudItemComponent<Firearm, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  assetSelectionList: Asset[];

  calibreSelectionList: RefCode[];

  currentAssignmentFirearmAssignmentStorageTypeSelectionList: RefCode[];

  currentAssignmentFirearmAssignmentTypeSelectionList: RefCode[];

  firearmTypeSelectionList: RefCode[];

  lifecycleStateSelectionList: RefCode[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected firearmService: FirearmService,
    protected assetService: AssetService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(FIREARM_TYPE, fb, elementRef, router, route, userStorage, dialog, firearmService, injector, snackbar);
  }

  createNewItem() {
    return new Firearm();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      assetId: [null, [requiredValidator,]],
      asset: [null, [requiredValidator,]],
      calibre: [null, [requiredValidator,]],
      currentAssignmentEmail: [null, []],
      currentAssignmentFirearmAssignmentStorageType: [null, []],
      currentAssignmentFirearmAssignmentType: [null, []],
      currentlyAssignable: [null, []],
      currentlyAssigned: [null, []],
      firearmPoolExisting: [null, []],
      firearmType: [null, [requiredValidator,]],
      importDataMap: [null, []],
      lifecycleState: [null, []],
      lockVersion: [null, []],
      personalFirearm: [null, []],
      poolFirearm: [null, []],
      suspended: [null, [requiredValidator,]]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.assetId?.disable();
    }
    this.currentAssignmentEmail?.disable();
    this.currentAssignmentFirearmAssignmentStorageType?.disable();
    this.currentAssignmentFirearmAssignmentType?.disable();
    this.currentlyAssignable?.disable();
    this.currentlyAssigned?.disable();
    this.firearmPoolExisting?.disable();
    this.lifecycleState?.disable();
    this.poolFirearm?.disable();
  }
  
  assetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.assetIdChangedByUser(value, unsetDependents);
    }
  }  
  
  assetIdChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  assetDisplay(item: Asset) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return ASSET_TYPE.description(item);
  }
  
  assetLoadSelectionList() {
    this.assetService.findAll().subscribe(
      data => {
        this.assetSelectionList = ASSET_TYPE.entityDecorator.ensureContained(this.item && this.item.asset, data.items);
      }
    );
  }

  assetChanging(value: Asset, unsetDependents: boolean = true) {}
  
  assetChanged(value: Asset, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.assetChangedByUser(value, unsetDependents);
    }
  }  
  
  assetChangedByUser(value: Asset, unsetDependents: boolean = true) {
  }
  
  assetCompare(a: any, b: any) {
    return ASSET_METADATA.equals(a, b);
  }
  
  calibreLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_CALIBRE').subscribe(
      data => {
        this.calibreSelectionList = data;
      }
    );
  }

  calibreChanging(value: string, unsetDependents: boolean = true) {}
  
  calibreChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.calibreChangedByUser(value, unsetDependents);
    }
  }  
  
  calibreChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  
  currentAssignmentFirearmAssignmentStorageTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_STORAGE_TYPE').subscribe(
      data => {
        this.currentAssignmentFirearmAssignmentStorageTypeSelectionList = data;
      }
    );
  }

  
  currentAssignmentFirearmAssignmentTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_ASSIGNMENT_TYPE').subscribe(
      data => {
        this.currentAssignmentFirearmAssignmentTypeSelectionList = data;
      }
    );
  }

  
  
  
  
  firearmTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_TYPE').subscribe(
      data => {
        this.firearmTypeSelectionList = data;
      }
    );
  }

  firearmTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  firearmTypeChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.firearmTypeChangedByUser(value, unsetDependents);
    }
  }  
  
  firearmTypeChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  importDataMapChanging(value: { [id: string]: any; }, unsetDependents: boolean = true) {}
  
  importDataMapChanged(value: { [id: string]: any; }, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.importDataMapChangedByUser(value, unsetDependents);
    }
  }  
  
  importDataMapChangedByUser(value: { [id: string]: any; }, unsetDependents: boolean = true) {
  }
  
  lifecycleStateLoadSelectionList() {
    this.refCodeStorage.getDomainElements('FIREARM_LIFECYCLE_STATE').subscribe(
      data => {
        this.lifecycleStateSelectionList = data;
      }
    );
  }

  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  personalFirearmChanging(value: boolean, unsetDependents: boolean = true) {}
  
  personalFirearmChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.personalFirearmChangedByUser(value, unsetDependents);
    }
  }  
  
  personalFirearmChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  
  
  suspendedChanging(value: boolean, unsetDependents: boolean = true) {}
  
  suspendedChanged(value: boolean, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.suspendedChangedByUser(value, unsetDependents);
    }
  }  
  
  suspendedChangedByUser(value: boolean, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get assetId() {
    return this.control('assetId');
  }
  
  get asset() {
    return this.control('asset');
  }
  
  get calibre() {
    return this.control('calibre');
  }
  
  get currentAssignmentEmail() {
    return this.control('currentAssignmentEmail');
  }
  
  get currentAssignmentFirearmAssignmentStorageType() {
    return this.control('currentAssignmentFirearmAssignmentStorageType');
  }
  
  get currentAssignmentFirearmAssignmentType() {
    return this.control('currentAssignmentFirearmAssignmentType');
  }
  
  get currentlyAssignable() {
    return this.control('currentlyAssignable');
  }
  
  get currentlyAssigned() {
    return this.control('currentlyAssigned');
  }
  
  get firearmPoolExisting() {
    return this.control('firearmPoolExisting');
  }
  
  get firearmType() {
    return this.control('firearmType');
  }
  
  get importDataMap() {
    return this.control('importDataMap');
  }
  
  get lifecycleState() {
    return this.control('lifecycleState');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get personalFirearm() {
    return this.control('personalFirearm');
  }
  
  get poolFirearm() {
    return this.control('poolFirearm');
  }
  
  get suspended() {
    return this.control('suspended');
  }
  
}





